import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import footerdata from '../../data/footerdata.json'
import AZCAlogo from '../../assets/img/AZCA-Logo.png'
import { CircularProgress } from '@material-ui/core'
import { SMTPClient } from 'emailjs'
import Swal from 'sweetalert2'
// const client = new SMTPClient({
// 	user: 'user',
// 	password: 'password',
// 	host: 'smtp.your-email.com',
// 	ssl: true,
// });

import Footerbackground from '../../assets/img/footerbackground.png'
import LogoTextWhite from '../../assets/img/logotextWhite.png'

class Footer_v1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      sent: false,
    }
  }

  componentDidMount() {
    let publicUrl = process.env.PUBLIC_URL + '/'
    const minscript = document.createElement('script')
    minscript.async = true
    minscript.src = publicUrl + 'assets/js/main.js'
    document.body.appendChild(minscript)
  }

  //send email from reactjs

  // function sendEmail(e) {
  //   e.preventDefault();

  //   emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID')
  //     .then((result) => {
  //         console.log(result.text);
  //     }, (error) => {
  //         console.log(error.text);
  //     });
  // }

  async handleSendEmail(e) {
    e.preventDefault()
    this.setState({ loading: true })
    try {
      setTimeout(() => {
        this.setState({ loading: false })
        Swal.fire(
          'Email Sent!',
          'Your email is sent with your detail',
          'success'
        )
      }, 2000)
    } catch (err) {
      console.error(err)
      this.setState({ loading: false })
    }
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + '/'
    let imgattr = 'Footer logo'
    const inlineStyle = {
      backgroundImage: 'url(' + publicUrl + footerdata.footerbg + ')',
    }

    return (
      <footer className='footer-area'
        style={{ backgroundImage: `url(${Footerbackground})`, backgroundSize: 'cover' }}
      >
        <div className='container'>
          {/* <div className='footer-top'>
            <div className='row'> */}
          {/* <div className='col-sm-4'>
                <a className='footer-logo' href='#'>
                  <img
                    src='/assets/img/azca-logo-new.png'
                    width='200'
                    height='50'
                    alt={imgattr}
                  />
                </a>
              </div> */}
          {/* </div>
          </div> */}

          <div className='footer-bottom'>
            <div className='row'>
              <div className='col-lg-4 col-sm-6'>
                <div className='widget widget_nav_menu'>
                  <a className='footer-logo' href='#'>
                    {/* <img src={publicUrl + footerdata.footerlogo} alt={imgattr} /> */}
                    <img
                      src={LogoTextWhite}
                      width='100%'
                      height='50'
                      alt={imgattr}
                    />
                  </a>
                  <p className="mt-4 w-75" >
                    AZCA is a Pakistan based developer of luxurious homes and
                    commercial buildings that provide an exceptional value to
                    aspiring property owners.
                  </p>
                </div>
              </div>
              <div className='col-lg-2 col-sm-6'>

                <div className='widget widget_nav_menu mt-4'>

                  <h5 style={{ color: '#fff' }}>
                    AZCA
                  </h5>
                  <p className="mt-4">
                    <a href='#/About'>ABOUT US</a>
                  </p>
                  <p>
                    <a href='#/About'>PROJECT</a>
                  </p>
                  <p>
                    <a href='#/About'>CAREER</a>
                  </p>
                  <p>
                    <a href='#/About'>BLOG</a>
                  </p>
                  {/* <p>
                    <i className='fa fa-phone mr-2' />
                    <a href='tel:051-5400175-6'>051-5400175-6</a>
                  </p>
                  <p>
                    <i className='fa fa-whatsapp mr-2' />
                    <a href='https://api.whatsapp.com/send?phone=03356911169'>
                      0335 6911169
                    </a>
                  </p>
                  <p>
                    <i className='fa fa-map-marker mr-2' />
                    <a
                      target='blank'
                      href='https://maps.app.goo.gl/5oMffoZvKLHsQnpc6'
                    >
                      Open location
                    </a>
                  </p>
                  <p>
                    <i className='fa fa-map mr-2' />
                    <Link to='/maps'>Maps</Link>
                  </p>
                  <p>
                    <i className='fa fa-question mr-2' />
                    <Link to='/contact'>Request a callback</Link>
                  </p> */}
                  {/* <h4 className="widget-title">{footerdata.Homepress.title}</h4>
                  <ul>
                    {footerdata.Homepress.links.map((item, i) => (
                      <li className="readeal-top" key={i}>
                        <Link to={item.url}>{item.title}</Link>
                      </li>
                    ))}
                  </ul> */}
                </div>
              </div>
              <div className='col-lg-3 col-sm-6'>
                <div className='widget widget_nav_menu'>
                  <div className='widget widget_nav_menu mt-4'>

                    <h5 style={{ color: '#fff' }}>
                      CONTACT
                    </h5>
                    <p className="mt-4">
                      <a href='tel:05154001756'>051-5400175-6</a>
                    </p>
                    <p>
                      <a href='tel:03356911169'>0335 6911169</a>
                    </p>
                    <p>
                      <a
                        target='blank'
                        href='https://maps.app.goo.gl/5oMffoZvKLHsQnpc6'
                      >
                        OPEN LOCATION
                      </a>
                    </p>
                    <p>
                      <Link to='/maps'>MAPS</Link>
                    </p>
                    <p>
                      <Link to='/contact'>REQUEST A CALLBACK</Link>
                    </p>
                  </div>

                </div>
              </div>
              <div className='col-lg-3 col-sm-6'>
                <form className='widget widget-subscribe'>
                  {/* <div className='rld-single-input'>
                    <input type='text' name='name' placeholder='Name' />
                  </div> */}
                  <div className='footer-social text-sm-left'>
                    <span style={{ color: '#fff' }}>FOLLOW US</span>
                    <ul className='social-icon mt-2'>
                      {footerdata.socialicon.map((item, i) => (
                        <li key={i}>
                          <a href={item.url} target='_blank'>
                            <i style={{ color: '#74797D' }} className={item.icon} />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className='rld-single-input mt-4'>
                    <input
                      type='email'
                      name='email'
                      placeholder='Your@email.com'
                    />
                  </div>
                  {/* <div className="rld-single-input">
                    <input type="number" name="phone" placeholder="Phone" />
                  </div> */}
                  {!this.state.loading ? (
                    <div>
                      <button
                        onClick={(e) => this.handleSendEmail(e)}
                        className='btn btn-yellow w-100'
                        style={{ backgroundColor: "#1d1f29" }}
                      >
                        Subscribe
                      </button>
                      <div className='d-flex justify-content-center'>
                        {this.state.sent && <p>Email sent</p>}
                      </div>
                    </div>
                  ) : (
                    <div className='d-flex justify-content-center mt-2'>
                      <CircularProgress />
                    </div>
                  )}{' '}
                </form>
              </div>
            </div>
          </div>
          <div
            className='copy-right text-center' style={{
              color: "#fff",
            }}
            dangerouslySetInnerHTML={{ __html: footerdata.copyrighttext }}
          ></div>
        </div>
      </footer >
    )
  }
}

export default Footer_v1
